<div class="weigh-transport-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'weigh transport' | translate: ['tmc.weigh-transport-dialog.title', translationService.language]}}
    </h2>
    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
        [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <div class="weigh-transport-dialog-layout">
        <form #inputForm="ngForm" class="weigh-input-form">
          <sc-flex >
            <mat-form-field class="flex-grow-1">
              <input name="value" matInput [(ngModel)]="value" #ctrlValue="ngModel" type="number" min="0" [max]="cps.getClientParamValue('ui-component.transport-details.weighing.max-weight', 50000)"
                placeholder="{{'weight' | translate: ['tmc.weigh-transport-dialog.label.value', translationService.language]}}"
                [readonly]="false" required appPositiveInteger>
              <mat-error *ngIf="showValuePositiveIntegerError(ctrlValue)">
                {{'value must positive and Integer' | translate: ['tmc.weigh-transport-dialog.error.value-no-integer',
                translationService.language]}}
              </mat-error>
            </mat-form-field>
            <sc-content-spacer></sc-content-spacer>
            <mat-form-field class="margin-left flex-grow-1" *ngIf="isAutoWeighingVisible()">
              <mat-label>
                {{'source' | translate: ['tmc.weigh-transport-dialog.label.source', translationService.language]}}
              </mat-label>
              <mat-select name="source" [(ngModel)]="source" #ctrlType="ngModel">
                <mat-option *ngFor="let o of sourceOptions" value="{{o}}">
                  {{o | translate: ['tmc.weighing.auto.sources.label.'+o, translationService.language]}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-icon-button class="weighingButton" (click)="readWeight()"
              [matTooltip]="'Weigh Transport' | translate: ['tmc.visit.overview.action.weighTransport', translationService.language]"
              *ngIf="cps.isEnabled(clientParameters.P_VISITS_WEIGHING_ENABLED, false) && isAutoWeighingVisible()">
              <sc-icon iconClass="fa-balance-scale"></sc-icon>
            </button>
            <sc-content-spacer></sc-content-spacer>
            <mat-form-field class="margin-left flex-grow-1">
              <mat-label>
                {{'type' | translate: ['tmc.weigh-transport-dialog.label.type', translationService.language]}}
              </mat-label>
              <mat-select name="type" [(ngModel)]="type" #ctrlType="ngModel" required>
                <mat-option *ngFor="let o of typeOptions" value="{{o}}">
                  {{o | translate: ['tmc.weigh-transport-dialog.weighingType.' + o, translationService.language]}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </sc-flex>
          <sc-flex>
            <sc-hint *ngIf="maxWeightExceeded()" class="weighingError" [dictionaryKey]="'tmc.weigh-transport-dialog.error.weight-exceeded-error'" [type]="'error'"></sc-hint>
          </sc-flex>
          <sc-flex >
            <mat-form-field class="date-field margin-left">
              <input name="date" matInput [(ngModel)]="date" #ctrlDate="ngModel" type="date"
                placeholder="{{'date' | translate: ['tmc.weigh-transport-dialog.label.date', translationService.language]}}"
                [readonly]="false" required>
            </mat-form-field>
            <sc-content-spacer></sc-content-spacer>
            <mat-form-field class="margin-left">
              <input name="time" matInput [(ngModel)]="time" #ctrlTime="ngModel" type="time"
                placeholder="{{'time' | translate: ['tmc.weigh-transport-dialog.label.time', translationService.language]}}"
                [readonly]="false" required>
            </mat-form-field>
            <sc-content-spacer></sc-content-spacer>
            <button class="margin-left add-button" mat-stroked-button (click)="addWeighing()"
              [disabled]="isAddWeighingDisabled()"
              [matTooltip]="'add weighing' | translate:['tmc.weigh-transport-dialog.action.addWeighing', translationService.language]">
              <sc-icon iconClass="fa-plus"></sc-icon>
            </button>
          </sc-flex>
        </form>
        <div class="weigh-table-container">
          <sc-tmc-table [tableModel]="tableModel" [hideFilter]="true" #tmcTableComponent></sc-tmc-table>
        </div>
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
      </div>
    </div>

    <i class="horizontal-divider"></i>
    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <sc-actionbar>
      <button class="confirm-button" mat-stroked-button (click)="createPrintout()"
        [matTooltip]="'create printout' | translate:['tmc.weigh-transport-dialog.action.createPrintout', translationService.language]">
        {{'create printout' | translate:['tmc.weigh-transport-dialog.action.createPrintout',
        translationService.language]}}
        <sc-icon iconClass="fa-print"></sc-icon>
      </button>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button (click)="closeDialog()" [disabled]="isCloseDialogDisabled()">{{'cancel' |
        translate:['tmc.weigh-transport-dialog.action.close', translationService.language]}}</button>
    </sc-actionbar>
  </div>
